import { LlmOutputTypesEnum } from '@eluve/graphql-types';

export const LlmOutputTypeLabels: Record<LlmOutputTypesEnum, string> = {
  BILLING_CODE_RECOMMENDATION: 'Billing Code Recommendation',
  CHIEF_COMPLAINT: 'Chief Complaint',
  CLIENT_RECAP: 'Client Recap',
  DIAGNOSES_JUSTIFICATION: 'Diagnoses Justification',
  DIFFERENTIAL_DIAGNOSES_PLUS_RED_FLAGS: 'Differential Diagnoses + Red Flags',
  DIFFERENTIAL_DIAGNOSES: 'Differential Diagnoses',
  DYNAMIC_OUTPUT: 'Dynamic Output',
  FACT_GENERATION: 'Fact Generation',
  FACT_VERIFICATION: 'Fact Verification',
  GENERIC_OUTPUT: 'Generic Output',
  MEDICINE_RECOMMENDATION: 'Medicine Recommendation',
  PATIENT_OVERVIEW: 'Patient Overview',
  PFSH: 'Past, Family and Social History',
  PII_REMOVAL: 'PII Removal',
  REVIEW_OF_SYSTEMS: 'Review of Systems',
  SOAP_NOTE: 'SOAP Note',
  TRANSCRIPTION: 'LLM Powered Transcription',
  TRANSLATION: 'Translation',
  CHAT: 'Chat Insights',
  PREVISIT_INSIGHTS: 'Pre-visit Insights',
};
